<template>
  <section class=" card">

    <header class="card-header">
      <p class="card-header-title">Support Device Tag</p>
      <button class="card-header-icon">
      <span >
        <b-tag type="is-grey-light">Silver 70x32</b-tag>
      </span>
      </button>

    </header>
    <div class="card-content">
      <b-field label="Templates">
        <p class="control">
          <b-button @click="setTemplate('fixed')" size="is-small" icon-left="content-copy">Fixed Install</b-button>
        </p>
        <p class="control">
          <b-button @click="setTemplate('kitcomponent')" size="is-small" icon-left="content-copy">Internal Switch</b-button>
        </p>

      </b-field>
      <b-field label="Line 1 - Bold">
        <b-input v-model="line1" :placeholder="line1_plc" maxlength="30">
        </b-input>
      </b-field>
      <b-field label="Line 2">
        <b-input v-model="line2" :placeholder="line2_plc" maxlength="30">
        </b-input>
      </b-field>
      <b-field label="Line 3">
        <b-input v-model="line3" :placeholder="line3_plc" maxlength="30">
        </b-input>
      </b-field>
      <b-field label="Line 4">
        <b-input v-model="line4" :placeholder="line4_plc" maxlength="30">
        </b-input>
      </b-field>
      <b-field label="Tag & QR Code Data">
        <b-input v-model="qr" :placeholder="qr_plc" maxlength="30">
        </b-input>
      </b-field>

      <b-field grouped>
        <b-field label="Show Preview">
          <p class="control">
            <b-button class="button is-primary" @click="previewZPL">Preview</b-button>
          </p>
        </b-field>

        <b-field
            label="Amount"
            type="is-primary">
          <b-select v-model="amountOfLabels">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="3">3</option>
            <option :value="4">4</option>
            <option :value="5">5</option>
            <option :value="6">6</option>
          </b-select>
        </b-field>
        <b-field label="Print">
          <b-button @click="printZPL">
            Print Tags
          </b-button>
        </b-field>
      </b-field>


    </div>

  </section>
</template>

<script>

import moment from "moment/moment";

export default {
  data() {
    return {
      amountOfLabels: 1,
      line1: '',
      line1_plc: '',
      line2: '',
      line2_plc: '',
      line3: '',
      line3_plc: '',
      line4: '',
      line4_plc: '',
      qr: '',
      qr_plc: '',

    };
  },
  methods: {

    setTemplate(template) {
      switch(template) {
        case "fixed":
          this.line1_plc = "Enter Project name..."
          this.line2 = "IP: "
          this.line3 = "Location: "
          this.qr_plc = "Enter Asset tag..."
          break;

        case "kitcomponent":
          this.line1_plc = "Enter model name..."
          this.line2 = "IP LOC: "
          this.line3 = "IP REM: "
          this.line4 = "IP OOB: "
          this.qr_plc = "Enter Asset tag..."

          break;

      }

    },

    previewZPL() {
      this.$emit("previewZPL", this.generateLabelZPL(), )
    },

    printZPL() {

      let res = []
      for (let i = 0; i < this.amountOfLabels; i++) {
        res.push(this.generateLabelZPL())
      }

      this.$emit("printZPL", res)
    },

    generateLabelZPL() {
      var currentDate = moment().format('DD/MM/YYYY');

      return `^XA ^PW560
              ^FO476,20^GFA,2400,2400,10,,:::::::U0F,T07FC,S03IF,U03F,V078,V03C,W0C,W04,Q02K02,Q04,Q08,P018,P03,P07,:P0F,::::P07,:P03,P038,P018,Q0C,Q02K02,W04,W0C,V01C,V078,U01F8,S03IF,T0FFE,T01F8,,:::::::::::S0FE,R03FF8,R07C7C,R0F01E,Q01C007,Q018003,Q0380038,:Q03I018,:::Q0380038,:Q01C007,:R08002,,::::::::Q03IF8,Q03IFC,Q03JF,,:::::::U018,:::::U038,Q03JF8,:U038,U018,:::::,::::V08,U038,U078,T01F,T03C,T0F8,S03E,S078,Q03FF,:S078,S01E,T0F8,T03C,U0F,U078,U018,,:::::::Q03JF8,::T01F,T07C,T0F,S03C,S0F8,S06,,:R018,R01E,S0F8,S03C,T0F,T07C,T01E,Q03JF8,::,::::::::::Q03JF8,:Q0383838,Q0301818,::::::::Q03I018,Q01,,:::::::Q01C07C,Q0180FE,Q0380FF,Q0381C38,Q0301838,Q0301818,Q0303818,:Q0303018,Q0307018,Q0387038,Q01FE03,:R078,,::::::::Q03JF8,::S038,S018,::::::::S038,Q03JF8,::,:::::::^FS
              ^CF0,22 ^FO180,35^FB325,1,4,L,0^FD${this.line1}^FS
              ^CFP,22 ^FO180,70^FB320,3,5,L,0^FD${this.line2}^FS
              ^CFP,22 ^FO180,100^FB320,3,5,L,0^FD${this.line3}^FS
              ^CFP,22 ^FO180,130^FB320,3,5,L,0^FD${this.line4}^FS
              ^CF0,15 ^FO362,156^FDprinted on ${currentDate}^FS
              ^CF0,15 ^FO230,176^FD support@citymesh.com | +32 50 96 96 87^FS
              ^FO20,20 ^BQN,2,6 ^FDQA,${this.qr}^FS
              ^FO0,195^GB500,90,90^FS
              ^LRY ^CF0,45,50 ^FO20,210^FD${this.qr}^FS
              ^LRN ^XZ`

    },

  },
};
</script>
